<template>
	<section>
		<compWrapper :title="$t('global.common.base_information',{defaultValue:'基本信息'})" theme="primary">
			<compFormQuery
				v-if="isQuery"
				class="margin-layout"
				:formdata="getBase"
				:value="formData"
				placeholder="--"
			></compFormQuery>
			<compFormEdit v-else ref="formbase" class="margin-layout" :formdata="getBase" v-model="formData"></compFormEdit>
		</compWrapper>
        <compWrapper
			:title="$t('fbb.misc.outbound_product',{defaultValue:'出库产品信息'})"
			theme="primary"
		>
			<compProduct
				class="margin-layout"
				ref="productlist"
				:data="productList"
				:baseData="formData"
				:querytype="querytype"
			></compProduct>
			<vButtonGroup slot="footer"  v-if="!alertbox">
				<vButton
					v-for="item in getStatusBtns"
					:key="item.name"
					@click="item.run"
					:theme="item.theme"
				>{{item.name}}</vButton>
			</vButtonGroup>
		</compWrapper>
		<compWrapper v-if="type==='query'" :title="$t('global.log.name',{defaultValue:'操作历史'})" theme="gray">
			<vTable class="margin-15" :columns="getLogColumns" :data="logList" border></vTable>
			<div class="text-right margin-right-15" v-if="alertbox">
				<vButton
					class="margin-left-10"
					v-for="item in getStatusBtns"
					:key="item.name"
					@click="item.run"
					:theme="item.theme"
				>{{item.name}}</vButton>
			</div>
		</compWrapper>
		<vLoading size="large" transfer :loading="loading"></vLoading>
		<compModal
			v-model="modalProps.show"
			v-bind="modalProps"
			@on-close="modalProps.show=false"
			@on-confirm="back"
		>
			<component
				v-if="modalProps.component"
				:is="modalProps.component"
				v-bind="modalProps"
				v-on="modalProps.on"
			/>
		</compModal>
		
	</section>
</template>
<script>
import {HttpAddMiscOutbound,
HttpUpdateMiscOutbound,
HttpHostAndCustomerWarehouse,
HttpMiscOutbound,
HttpSureMiscOutbound,
HttpCancelMiscOutbound,
HttpSaveAndSureMiscOutbound
} from '@/service/misc';

import { mapGetters } from 'vuex';
import mixin from "../mixin";
import compProduct from './product';
export default {
    mixins: [mixin],
	props: ['activeid','querytype','alertbox'],
	components: {
        compProduct
    },
    data() {
		return {
			loading: false,
			type: this.querytype || this.$route.params.type,
            id:  this.activeid || this.$route.query.id,
			showModal: false,
			formData: {
			},
			productList: [],//出库计划单明细,
			logList: [],//log,
			warehouseList: [],
			modalProps: {
				show: false,
				// title: '导入数据',
				// component: "",
				// props: {},
				// on: {},
			},
        };
    },
    watch: {
        "formData.organizationId": {
            immediate: true,
            handler (orgId) {
                if (!orgId) return;
                this.getWarehouse(orgId);
            }
        }
    },
    created() {
		this.getDetail();
		
    },
    computed: {
        ...mapGetters('dictionary', ['getProductList', 'getOrgList', 'getCountryList', 'getFilterDisabledWarehouse','getSelfmanageorgList']),
                isEdit() {
			return this.type === 'edit'
		},
		isQuery() {
			return this.type === 'query'
		},
		isAdd() {
			return this.type === 'add'
        },
        getStatusBtns() {
			const btn = [ {
				name: this.$t('fbb.inbound.save_draft', { defaultValue: '保存为草稿' }),
				show: this.isAdd || this.isEdit ,
				theme: 'primary',
				run: this.save
			},{
				name: this.$t('global.datepicker.confirm', { defaultValue: '确认' }),
				show: this.formData.miscOutboundStatus == 0 || this.isAdd,
				theme: 'success',
				run: this.sure
			},{
				name: this.$t('global.common.operation_cancel', { defaultValue: '取消' }),
				show:  this.formData.miscOutboundStatus == 0 && !this.isEdit,
				theme: 'error',
				run: this.cancel
			},{
				name: this.$t('global.common.return', { defaultValue: '返回' }),
				show: true,
				theme: 'info',
				run: this.back
			}

			]

			return btn.filter(item => item.show);
        },

        getBase() {
			let base = [{
				label: this.$t('fbb.misc.outbound_no', { defaultValue: '其他出库单号' }),
				key: "miscOutboundNo",
				query: true,
                show: this.isEdit || this.isQuery,
			},{
			    label: this.$t('global.common.organization', { defaultValue: '组织' }),
                tag: 'vSelect',
                key: 'organizationId',
                options: this.getSelfmanageorgList,
                props: {
                    filterable: true,
				},
				on: {
					'on-change': (val) => {
						this.getWarehouse(val);
					}
				}
			},{
				label: this.$t('fbb.alloment.warehouse_out', { defaultValue: '出库仓库' }),
				key: this.isQuery ? "orgWarehouseCode" : "orgWarehouseId",
				tag: "vSelect",
				options: this.isQuery ? null : this.warehouseList,
				props: {
					filterable: true
				},
			},{
				label: this.$t('global.common.status', { defaultValue: '状态' }),
				tag: "vSelect",
				key: "miscOutboundStatus",
				show: this.isQuery,
				options: this.getBillStatus
			},{
				label: this.$t('fbb.inbound.inventory_type', { defaultValue: '库存类型' }),
				tag: "vSelect",
				key: "inventoryType",
				options: this.getInventoryType
			},
			{
				label: this.$t('global.common.source_number', { defaultValue: '来源单号' }),
				key: "sourceNo",
				required: false,
			},
			{
				label: this.$t('fbb.costmanage.work_type', { defaultValue: '业务类型' }),
				tag: "vSelect",
				key: "type",
				options: this.getOutType
			},
			{
				label: this.$t('fbb.misc.ref_no', { defaultValue: '关联单据号' }),
				key: "refNo",
				required: false,
			},
			{
				label: this.$t('global.common.notes', { defaultValue: '备注' }),
				tag: "vTextarea",
				key: "remark",
				required: false,
			},
			];
            // 组织下拉列表如果只有1项，直接设置默认值，添加、编辑不展示
            if (this.getSelfmanageorgList.length === 1) {
                
                if (!this.isQuery) {
                    this.$set(this.formData, 'organizationId', this.getSelfmanageorgList[0].value);
                    base.splice(1, 1);
                }
            }
			return base;
        },
        getLogColumns() {
			return [{
				title: this.$t('global.common.operator', { defaultValue: '操作人' }),
				key: 'createdName',
			}, {
				title: this.$t('global.common.operate_type', { defaultValue: '操作类型' }),
				key: 'opAction',
				render: (h, { row }) => {
					return this.getLogActions[row.operateType] || '';
				},
			}, {
				title: this.$t('global.common.notes', { defaultValue: '备注' }),
				key: 'remark',
				width: "30%"

			},{
				title: this.$t('global.common.operate_time', { defaultValue: '操作时间' }),
				key: 'createdAt',
			}];
		}
    },
    methods: {
		getWarehouse(orgId) {
            HttpHostAndCustomerWarehouse({
                contextId:global.SYSID,
                orgId: orgId,
            }).then(
                (res) => {
                    this.warehouseList = res.data.map(item => {
                        return {
                            value: item.id,
                            label: `${item.code}(${item.title})`,
                            attach: {
                                ...item
                            }
                        }
                    });
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
        },
        //保存
        async save() {
			const valid = await this.$refs.formbase.validate();
			if (!valid) return;
			this.loading = true;
			const ajaxRequest = this.isAdd ? HttpAddMiscOutbound : HttpUpdateMiscOutbound
			return ajaxRequest({
				...this.formData,
				miscOutboundOrderItemModels:this.$refs.productlist.dataList
			}).then(res => {
				this.loading = false;
				this.back();
			}, err => {
				this.loading = false;
				this.$VMessage.error(err.message);
			});
		},
		async sure() {
			const ajaxRequest = (this.isAdd || this.isEdit) ? HttpSaveAndSureMiscOutbound : HttpSureMiscOutbound
			if(this.isAdd || this.isEdit){
				const valid = await this.$refs.formbase.validate();
				if (!valid) return;
				this.modalProps = {
					show: true,
					alert: "success",
					title: this.$t('global.datepicker.confirm', { defaultValue: '确认' }),
					width: 'middle',
					showDesc: false,
					params: {...this.formData,
				miscOutboundOrderItemModels:this.$refs.productlist.dataList },
					ajaxRequest: ajaxRequest,
					formdata: [
						{
							tag: "vTextarea",
							key: "sureRemark",
							labelWidth: 'auto',
							span: 24,
							required: false,
							label: this.$t('global.common.notes', { defaultValue: '备注' })
						}
					]
				}
			}else{
				this.modalProps = {
					show: true,
					alert: "success",
					title: this.$t('global.datepicker.confirm', { defaultValue: '确认' }),
					width: 'middle',
					showDesc: false,
					params: { id: this.id },
					ajaxRequest: ajaxRequest,
					formdata: [
						{
							tag: "vTextarea",
							key: "remark",
							labelWidth: 'auto',
							span: 24,
							required: false,
							label: this.$t('global.common.notes', { defaultValue: '备注' })
						}
					]
				}
			}
		},
		cancel() {
			this.modalProps = {
				show: true,
				alert: "error",
				title: this.$t('global.common.cancel', { defaultValue: '取消' }),
				width: 'middle',
				showDesc: false,
				params: { id:  this.id },
				ajaxRequest: HttpCancelMiscOutbound,
				formdata: [
					{
						tag: "vTextarea",
						key: "cancelReason",
						labelWidth: 'auto',
						span: 24,
						required: false,
						label: this.$t('fbb.inbound.cancel_reason', { defaultValue: '取消原因' })
					}
				]
			}
		},
		back() {
			if (this.alertbox) {
				this.$emit('on-update')
			} else {
				this.$router.push({
				name: 'miscOutbound'
			})
			}
		},
		//获取详情
		getDetail() {
			if (this.isAdd) return;
			this.loading = true;
			if(this.id){
				HttpMiscOutbound({ id: this.id }).then(res => {
					this.loading = false;
					const data = res.data;
					this.productList = data.miscOutboundPlanOrderItemList || [];
					this.logList = data.orderLogList;
					this.formData = data;
					this.getWarehouse(this.formData.organizationId);
				}).catch(err => {
					this.loading = false;
					this.$VMessage.error(err.message);
				})
			}
			
		},

    },
    

}
</script>